import React from 'react';
import { ModifierGroupInterface } from '../../../services/exports/Interfaces';
import NestedModifierGroup from './NestedModifierGroup';
import { BasketLineItemModifier } from '../../../store/types';
import BackIcon from '../../../assets/logo/BackIcon';
import Theme from '../../Theme';
import { useTranslation } from 'react-i18next';

type NestedModifiersProps = {
  data: ModifierGroupInterface[];
  selectedModifiers: BasketLineItemModifier[];
};

const NestedModifiers = (props: NestedModifiersProps) => {
  const { data, selectedModifiers } = props;
  const getModifiersByGroup = (modifierGroupId: number): BasketLineItemModifier[] =>
    selectedModifiers.filter((modifier) => modifier.modifier_group_id === modifierGroupId);
  const hasEditButton = true;
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:NestedModifiers' });

  return (
    // TODO: move to props
    <div className="bg-gray rounded-xl p-2 gap-2 flex-col mb-4">
      {data.map((modifierGroup) => (
        <NestedModifierGroup
          key={modifierGroup.id}
          modifierGroup={modifierGroup}
          selectedModifiers={getModifiersByGroup(modifierGroup.id)}
        />
      ))}
      <div className="flex items-center justify-between mt-6">
        <p className="font-medium">{t('edit_selection')}</p>
        {hasEditButton && <BackIcon className="size-3 rotate-180" color={Theme.color.gray[700]} />}
      </div>
    </div>
  );
};

export default NestedModifiers;
